import { useTranslation } from 'react-i18next'

/** Explique l'astérisque des champs obligatoires, en tête de formulaire (RGAA 11.10). */
function RequiredFieldsHint() {
  const { t } = useTranslation()
  return <p className="text-xs text-muted-foreground">{t('form.requiredHint')}</p>
}

export default RequiredFieldsHint
